import { GridscaleObjects } from './GridscaleObjects.js';
class PaasDeprecatedClusters extends GridscaleObjects {
  api;
  constructor(_api) {
    super(_api, '/objects/paas/deprecated_kubernetes_clusters');
    this.api = _api;
  }
}
export { PaasDeprecatedClusters };
